import React, { Component } from 'react';

class LogoText extends Component {
  render() {
    return <span className={'logo'}>ExamSecure</span>;
  }
}

export default LogoText;
